import React from 'react'

const Logout = () => {
    return (
        <div>

        </div>
    )
}

export default Logout
